<template>
  <div class="contact">
    <div class="contact__title">{{ $t('contactPop.contactTitle', { index: index + 1 }) }}</div>
    <div class="contact__item">
      <div class="contact__item-label">{{ $t('contactPop.relation') }}</div>
      <div class="contact__item-value" :class="{ active: hasRelation }">
        <div class="contact__relation mg-t-12" @click="openSelection">{{ relationText }}</div>
      </div>
    </div>

    <div class="contact__item">
      <div class="contact__item-label">{{ $t('contactPop.name') }}</div>
      <div class="contact__item-value">
        <input class="contact__input mg-t-12" maxlength="50" type="text" :value="contact.name"
          @input="handleNameInput" />
      </div>
    </div>

    <div class="contact__item">
      <div class="contact__item-label">{{ $t('contactPop.phone') }}</div>
      <div class="contact__item-value">
        <input class="contact__input mg-t-12" type="tel" maxlength="13" :value="contact.phone"
          @input="handlePhoneInput" />
      </div>
    </div>
    <Picker ref="picker" :valueKey="valueKey" :columns="pickerData" @confirm="onPickerConfirm"></Picker>
  </div>
</template>
<script>
import Picker from '@/components/picker.vue';
import i18n from '@/i18n/index';
import { LANGUAGE, RELATIONSHIP_TYPE } from '@/common/constants';
export default {
  name: 'ContactItem',
  props: {
    index: {
      type: Number,
      default: 0
    },
    contact: {
      type: Object,
      default: () => {
        return {
          name: '',
          phone: '',
          relation: null
        }
      },
    },
  },
  components: {
    Picker
  },
  computed: {
    valueKey() {
      if (i18n.locale === LANGUAGE.en) return 'textEn';
      if (i18n.locale === LANGUAGE.id) return 'textId';
      return 'textPh';
    },
    hasRelation() {
      return !!this.contact.relation;
    },
    relationText() {
      if (this.hasRelation) {
        let { textEn, textPh } = this.contact.relation;
        if (i18n.locale === LANGUAGE.en) return textEn;
        if (i18n.locale === LANGUAGE.id) return this.contact.relation.textId;
        return textPh;
      } else {
        return '';
      }
    }
  },

  data() {
    return {
      pickerData: RELATIONSHIP_TYPE,
    }
  },
  methods: {
    handleNameInput(event) {
      let name = event.target.value.trimStart();
      this.$emit('update:contact', {
       index: this.index,
       data: {
         ...this.contact,
         name: name
       }
      })
    },
    handlePhoneInput(event) {
      // Android 同样只保留数字；后端手机号允许带国家码，页面最多保留 13 位。
      let value = event.target.value.replace(/[^\d]/g, '');
      value = value.slice(0, 13);
      this.$emit('update:contact', {
        index: this.index,
        data: {
          ...this.contact,
          phone: value
        }
      })
    },
    openSelection() {
      this.$refs.picker.open();
    },
    onPickerConfirm(value) {
      this.$emit('update:contact', {
        index: this.index,
        data: {
          ...this.contact,
          relation: value || null
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.contact {
  &__title {
    color: #0B1744;
    font-size: 30px;
    line-height: 40px;
  }

  &__item {
    margin-top: 22px;

    &-label {
      color: #333333;
      font-weight: 400;
      font-size: 28px;
      line-height: 36px;
    }
  }

  &__input {
    width: 100%;
    border: 1px solid var(--border-color-base);
    border-radius: 14px;
    padding: 0 20px;
    box-sizing: border-box;
    height: 72px;
    font-size: 36px;
    line-height: 72px;
  }

  &__relation {
    background: #FFFFFF;
    border-radius: 14px;
    border: 1px solid #D8D8D8;
    padding: 0 20px;
    font-weight: 400;
    font-size: 28px;
    height: 72px;
    color: var(--text-color-gray);
    line-height: 72px;
    text-align: left;
    box-sizing: border-box;
    position: relative;
    &::after {
      position: absolute;
      content: '';
      width: 24px;
      height: 24px;
      right: 20px;
      top: 50%;
      background: #ffffff url(~@/assets/img/next.png) no-repeat right center/ auto 24px;
      transform: translateY(-50%) rotate(90deg);
    }
  }
}

.active {
  .contact__relation {
    color: var(--text-color-black);
  }
}
</style>
